import React from 'react';
import { Button, Flex, Text } from 'core/components';

// Every request is answered but the answer still waits; Cancel is the way out if it never resumes.
const PendingRequestHint = ({ awaitingResponse, onCancel }) => (
  <Flex alignItems="center" gap={1} mb={1}>
    <Text small muted>
      {awaitingResponse ? 'Respond to the request above to continue.' : 'Continuing…'}
    </Text>
    {!awaitingResponse && onCancel && (
      <Button small minimal onClick={onCancel}>
        Cancel
      </Button>
    )}
  </Flex>
);

export default PendingRequestHint;
